<template>
  <t-filter-wrapper :label="$t('fields.occupations')">
    <OccupationSelect
      :value="value"
      multiple
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
  </t-filter-wrapper>
</template>

<script>
import OccupationSelect from '~/components/ResourceSelect/OccupationSelect';

export default {
  components: {
    OccupationSelect,
  },

  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>
